import React from 'react';

const CopyToast = () => (
	<div className="copy-toast">
		<i className="vngage-icon-doc-add"/>
	</div>
);

export default CopyToast;
